// truncate decimals without side-effects of rouding
// truncateDecimals(1.267777331225157671, 4) will return 1.2677 etc
export const truncateDecimals = (amount: number, decimals: number) =>
  Math.floor(amount * 10 ** decimals) / 10 ** decimals || '0.0000';
